import { WrapperProps, Status } from "@googlemaps/react-wrapper";

const render = (status: Status) => {
  return <span>{`${status.toLowerCase()}...`}</span>;
};

type Props = {
  apiKey: string;
  libraries: ("drawing" | "geometry" | "places" | "visualization")[];
} & Pick<WrapperProps, "render">;

const MapWrapperProps: Props = {
  apiKey: process.env.NEXT_PUBLIC_GOOG_MAPS_KEY || "",
  libraries: ["places", "drawing"],
  render,
};

export default MapWrapperProps;
